/**
 * @generated SignedSource<<87ee31b3d20aed49e2be5ed6eb193f64>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddExperimentsObservationsInput = {
  input: ExperimentsObservationInput;
};
export type ExperimentsObservationInput = {
  flagName: string;
  observation: any;
  observationType: string;
  variantName: string;
};
export type ExperimentsRecordExperimentsObservationMutation$variables = {
  input: AddExperimentsObservationsInput;
};
export type ExperimentsRecordExperimentsObservationMutation$data = {
  readonly addExperimentsObservations: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null | undefined;
    readonly experimentsObservationNode: {
      readonly createdBy: {
        readonly id: string;
      } | null | undefined;
      readonly createdOn: any;
      readonly id: string;
      readonly observation: any;
      readonly observationType: string | null | undefined;
      readonly user: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  };
};
export type ExperimentsRecordExperimentsObservationMutation = {
  response: ExperimentsRecordExperimentsObservationMutation$data;
  variables: ExperimentsRecordExperimentsObservationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddExperimentsObservationsPayload",
    "kind": "LinkedField",
    "name": "addExperimentsObservations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExperimentsObservationNode",
        "kind": "LinkedField",
        "name": "experimentsObservationNode",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "observationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "observation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExperimentsRecordExperimentsObservationMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExperimentsRecordExperimentsObservationMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "2282344cf845acfc66456d7251e1a934",
    "id": null,
    "metadata": {},
    "name": "ExperimentsRecordExperimentsObservationMutation",
    "operationKind": "mutation",
    "text": "mutation ExperimentsRecordExperimentsObservationMutation(\n  $input: AddExperimentsObservationsInput!\n) {\n  addExperimentsObservations(input: $input) {\n    experimentsObservationNode {\n      id\n      observationType\n      observation\n      createdOn\n      user {\n        id\n      }\n      createdBy {\n        id\n      }\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7306cff536df48eb93c64ee192892ef8";

export default node;
